import tippy from 'tippy.js';

const defaults = {
  placement: 'top',
  theme: 'helios',
  animateFill: false
};

class TooltipContainer {
  constructor (element) {
    this.el = element;
    this.options = defaults;
  }

  init () {
    tippy(this.el, this.options);
  }
}

export default TooltipContainer;
